import React from 'react'
import CompetitionPolling from '../feature/LeaderBoard/CompetitionPolling'

const CompetitionPollingPage = () => {
    return (
        <CompetitionPolling />
    )
}

export default CompetitionPollingPage
